import { render, staticRenderFns } from "./part2_2.vue?vue&type=template&id=9be6ee26&"
import script from "./part2_2.vue?vue&type=script&lang=js&"
export * from "./part2_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports